import axios from '@/config/axios'
import { useQuery } from '@tanstack/react-query'
import type { UserGetMeResponse } from './type'
import { useLocation } from 'react-router'
import { authApi } from '@collable/ui'

export const apiGetMe = async (token?: string): Promise<UserGetMeResponse> => {
  const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {}
  const res = await axios.get(`/v1/me`, config)
  return res.data
}

export const useGetMe = () => {
  const location = useLocation()
  return useQuery({
    queryKey: [`/v1/me`],
    queryFn: () => apiGetMe(),
    placeholderData: previousData => previousData,
    enabled: !location.pathname.includes('/redirect'),
  })
}

export const apiSignOut = async () => {
  return authApi.signOut(axios)
}
